export var lastOrder = [
    {
        id: "3",
        urlPath: '../la-mer',
        urlImg: '../assets/deliverywatch.png',
        status: 'En cours de livraison',
        deliveryDate: '10/01/20',
        productNumber: '#B128D3QM1',
        price: '350,99€',
        cssClass: "",
        __typename: "MenuItem"
    },
    {
        id: "4",
        urlPath: '../la-mer',
        urlImg: '../assets/deliverywatch.png',
        status: 'En cours de livraison',
        deliveryDate: '20/01/20',
        productNumber: '#B128D3QM1',
        price: '250,99€',
        cssClass: "",
        __typename: "MenuItem"
    },
];
//# sourceMappingURL=DataDelivery.js.map